import {inject, Injectable} from '@angular/core';
import {DesignBlocksApiService} from "../services-api/design-blocks-api.service";

@Injectable({
  providedIn: 'root'
})
export class DesignBlocksService {
  private designBlocksApiService: DesignBlocksApiService = inject(DesignBlocksApiService);

  public initializeDesignBlocks(productCardId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.designBlocksApiService.initializeDesignBlocks(productCardId).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }
}
